import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Button } from 'react-bootstrap';
import { BsFillPencilFill } from 'react-icons/bs';
import { FaWindowClose } from 'react-icons/fa';
import { ModalTambahRole, ModalUbahRole } from '../../../../Modal';
import Swal from 'sweetalert2';
import { AgGridReact } from 'ag-grid-react';
import {
    AllCommunityModule,
    ModuleRegistry,
    colorSchemeDark,
    colorSchemeLightCold,
    DateFilterModule,
    themeQuartz
} from 'ag-grid-community';
import { ThemeContext } from '../../../../../auth';
import { useMediaQuery } from 'react-responsive';
import { axiosAuth } from '../../../../../api';

function TabsRoleDark({
    listRole,
    listDivisi,
    retrieveRole,
    accessToken,
}) {

    const isMobile = useMediaQuery({ maxWidth: 736 });

    const { theme } = useContext(ThemeContext);

    const [showTambahRole, setShowTambahRole] = useState(false);
    const handleShowTambahRole = () => {
        setShowTambahRole(true);
    };

    const [rowSelected, setRowSelected] = useState();
    const [showEditRole, setShowEditRole] = useState(false);
    const handleShowEditRole = (row) => {
        setShowEditRole(true);
        setRowSelected(row);
    };

    const handleDelete = async (rowId) => {
        const result = await Swal.fire({
            title: 'Apakah anda yakin ingin menghapus role ini?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ya, hapus role ini!',
            cancelButtonText: 'Batalkan',
        });

        if (result.isConfirmed) {

            try {
                const response = await axiosAuth.delete(`/api/roles/${rowId}`,
                    {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            withCredentials: true,
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );

                Swal.fire('Berhasil!', 'Role berhasil dihapus', 'success');
                retrieveRole();
            } catch (err) {
                if (!err?.response) {
                    Swal.fire('Error', 'Terjadi kesalahan saat menghapus divisi!', 'error');
                } else if (err.response?.status === 400) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...!',
                        text: `${err.response?.data.message}`,
                    })
                } else {
                    Swal.fire('Error', 'Terjadi kesalahan saat menghapus divisi!', 'error');
                }
            }
        } else {
            <></>
        }
    };

    ModuleRegistry.registerModules([AllCommunityModule, DateFilterModule]);

    const themeLightCold = themeQuartz.withPart(colorSchemeLightCold);
    const themecolorSchemeDark = themeQuartz.withPart(colorSchemeDark);

    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        if (listRole && listRole.length > 0) {
            setRowData(listRole);
        }
    }, [listRole]);

    const colDefs = [
        {
            field: "roleName",
            headerName: "Nama Role",
            sortable: true,
            sort: 'asc',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.roleName}
                    </div>
                );
            },
        },
        {
            field: 'ubah',
            headerName: 'Ubah',
            width: 100,
            pinned: 'right',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => handleShowEditRole(row.data)}
                    >
                        <Button
                            variant='btn'
                            onClick={() => handleShowEditRole(row.data)}
                        >
                            &nbsp;<BsFillPencilFill size={20} color={theme == 'light' ? '#12B3ED' : '#006CB8'} />&nbsp;
                        </Button>
                    </div>
                );
            },
        },
        {
            field: 'hapus',
            headerName: 'Hapus',
            width: 100,
            pinned: 'right',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => handleDelete(row.data.id)}
                    >
                        <Button
                            variant='btn'
                            onClick={() => handleDelete(row.data.id)}
                        >
                            &nbsp;<FaWindowClose size={20} color='#FF0060' />&nbsp;
                        </Button>
                    </div>
                );
            },
        },
    ];

    const defaultColDef = {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true
    };

    const [tableHeight, setTableHeight] = useState(window.innerHeight - 200); // Initial height

    useEffect(() => {
        const updateHeight = () => {
            setTableHeight(window.innerHeight - 200); // Adjust as needed
        };

        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    return (
        <div className='mt-3' style={{ height: tableHeight }}>
            <Button
                id={theme === 'light' ? 'actionButtonTabelDark' : 'actionButtonTabelLight'}
                variant='btn'
                style={{ color: theme === 'light' ? '#222' : 'white', fontSize: '14px' }}
                onClick={handleShowTambahRole}
            >
                Tambah
            </Button>

            <AgGridReact
                theme={theme === "light" ? themecolorSchemeDark : themeLightCold}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                pagination={isMobile ? false : true}
                rowHeight={30}
            />

            <ModalTambahRole
                showTambahRole={showTambahRole}
                setShowTambahRole={setShowTambahRole}
                listDivisi={listDivisi}
                retrieveRole={retrieveRole}
                accessToken={accessToken}
            />
            <ModalUbahRole
                rowSelected={rowSelected}
                showEditRole={showEditRole}
                setShowEditRole={setShowEditRole}
                listDivisi={listDivisi}
                retrieveRole={retrieveRole}
                accessToken={accessToken}
            />
        </div>
    )
}

export default TabsRoleDark
